const DEFAULT_READY_TTL_MS = 5 * 60 * 1000;

export function createBackendReadiness(check, { ttlMs = DEFAULT_READY_TTL_MS } = {}) {
  let readyUntil = 0;
  let inFlight = null;

  return () => {
    if (Date.now() < readyUntil) return Promise.resolve();
    if (inFlight) return inFlight;

    inFlight = Promise.resolve()
      .then(check)
      .then(result => {
        readyUntil = Date.now() + ttlMs;
        return result;
      })
      .finally(() => {
        inFlight = null;
      });

    return inFlight;
  };
}
